module.exports = __webpack_public_path__ + "static/media/ratherAgree@3x.51eae8f3.png";